import React from 'react'
import  './Banner1.css'

export default function Banner1() {
    return (
        <section id="banner">
            <h4>Repaire Servise</h4>
            <h2>Up to <span>70% Off - All </span> &amp; Accessories</h2>
            <button>Explore More</button>
        </section>
    )
}
